import React from 'react';

function Footer() {
  return <div className="op-footer">@Patco Per&uacute;</div>;
}

export default Footer;
